import React from 'react';
import PropTypes from 'prop-types';
import { colors } from 'utils/bulmaHelpers';
import cx from 'classnames';
import styles from './Navbar.module.scss';

const Navbar = ({ children, backgroundColor, color, className }) => {
  return (
    <nav style={{ backgroundColor }} className={cx(`navbar ${styles.root} is-${color} ${className}`)}>
      {children}
    </nav>
  );
};

Navbar.propTypes = {
  children: PropTypes.node,
  color: PropTypes.oneOf(colors),
  className: PropTypes.string,
};

export default Navbar;
